import { render, staticRenderFns } from "./HelpInfoComponent.vue?vue&type=template&id=4460fee8&scoped=true"
import script from "./HelpInfoComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelpInfoComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./HelpInfoComponent.vue?vue&type=style&index=0&id=4460fee8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460fee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4460fee8')) {
      api.createRecord('4460fee8', component.options)
    } else {
      api.reload('4460fee8', component.options)
    }
    module.hot.accept("./HelpInfoComponent.vue?vue&type=template&id=4460fee8&scoped=true", function () {
      api.rerender('4460fee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/loginForm/HelpInfoComponent.vue"
export default component.exports